module.exports = __webpack_public_path__ + "img/CS26Q-中_16.41c68b19.jpg";